<div class="grid">
  <div class="col-12">
    <div class="card">
      <div class="flex flex-wrap justify-content-end">
        <div *ngIf="machine?.model.machineType === 'ZITRUX'" class="flex">
          <span class="line-height-4 mr-1">
            <span class="text-xl font-semibold">{{'common.viewInLiters' | transloco}}</span>&nbsp;
          </span>
          <div class="mr-4 mt-1">
            <p-inputSwitch [(ngModel)]="viewInLiters" (onChange)="changeLiters($event)" [disabled]="this.isMachineLoading"></p-inputSwitch>
          </div>
        </div>
        <button
          [disabled]="this.isMachineLoading"
          [label]="'common.exportXls' | transloco"
          (click)="exportVisible = !exportVisible; exportFileType = ExportFileType.MACHINE_DATA"
          pButton
          class="p-button-secondary md:mr-2"
          icon="pi pi-file-excel"
        ></button>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4">
    <div class="card relative h-16rem">
      <div class="absolute top-0 left-0" [pTooltip]="squeezedValuesLastHourTranslation" tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isMachineLoading">
          <span *ngIf="!viewInLiters">{{'misc.overview.squeezedFruitsLastHour' | transloco}}</span>
          <span *ngIf="viewInLiters">{{'misc.overview.squeezedLitersLastHour' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div class="flex h-9rem">
        <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!this.isMachineLoading && (this.machineLastValues?.squeezedValuesLastHour == null || this.machineLastValues?.squeezedValuesLastHour == undefined
             || this.machineLastValues?.squeezedValuesLastHour < 0)">
            {{'empty.measures' | transloco}}
        </span>
        <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isMachineLoading && this.machineLastValues != null && this.machineLastValues?.squeezedValuesLastHour >= 0">
                    {{ this.machineLastValues.squeezedValuesLastHour | number: this.viewInLiters ? '.3-3' : '' : this.language }}</span>
        <p-skeleton class="m-auto" *ngIf="this.isMachineLoading" width="30%" height="3rem"></p-skeleton>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4">
    <div class="card relative h-16rem">
      <div class="absolute top-0 left-0" [pTooltip]="squeezedValuesLastDayTranslation">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isMachineLoading">
          <span *ngIf="!viewInLiters">{{'misc.overview.squeezedFruitsLastDay' | transloco}}</span>
          <span *ngIf="viewInLiters">{{'misc.overview.squeezedLitersLastDay' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div class="flex h-9rem">
        <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!this.isMachineLoading && (this.machineLastValues?.squeezedValuesLastDay == null || this.machineLastValues?.squeezedValuesLastDay == undefined
            || this.machineLastValues?.squeezedValuesLastDay < 0)">
            {{'empty.measures' | transloco}}
        </span>
        <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isMachineLoading && this.machineLastValues != null && this.machineLastValues?.squeezedValuesLastDay >= 0">
                    {{ this.machineLastValues.squeezedValuesLastDay | number:this.viewInLiters ? '.3-3' : '' : this.language }}</span>
        <p-skeleton class="m-auto" *ngIf="this.isMachineLoading" width="30%" height="3rem"></p-skeleton>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4">
    <div class="card relative h-16rem">
      <div class="absolute top-0 left-0" [pTooltip]="squeezedValuesLastMonthTranslation"
           tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isMachineLoading">
          <span *ngIf="!viewInLiters">{{'misc.overview.squeezedFruitsLastMonth' | transloco}}</span>
          <span *ngIf="viewInLiters">{{'misc.overview.squeezedLitersLastMonth' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div class="flex h-9rem">
        <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!this.isMachineLoading && (this.machineLastValues?.squeezedValuesLastMonth == null || this.machineLastValues?.squeezedValuesLastMonth == undefined
            || this.machineLastValues?.squeezedValuesLastMonth < 0)">
            {{'empty.measures' | transloco}}</span>
        <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isMachineLoading && this.machineLastValues != null && this.machineLastValues?.squeezedValuesLastMonth >= 0">
                    {{ this.machineLastValues.squeezedValuesLastMonth | number:this.viewInLiters ? '.3-3' : '' : this.language }}</span>
        <p-skeleton class="m-auto" *ngIf="this.isMachineLoading" width="30%" height="3rem"></p-skeleton>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card">
      <div class="flex flex-wrap justify-content-between">
        <span class="line-height-4">
            <span class="text-xl font-semibold">{{ 'attribute.period' | transloco}}:</span>&nbsp;
            <span *ngIf="!this.isSpecificPeriodSelected" class="text-md font-medium text-primary">{{ 'misc.' +
            selectedPeriod | transloco}}</span>
            <span class="text-md font-medium text-secondary" *ngIf="this.isSpecificPeriodSelected">
                {{ 'attribute.from' | transloco }} <b>{{this.specificPeriodRange[0] | date}}</b> {{
              'attribute.until' | transloco | lowercase}}
              <b>{{this.specificPeriodRange[1]
                | date}}</b>
            </span>
        </span>
        <button
          [label]="'common.filters' | transloco"
          (click)="filtersVisible = !filtersVisible"
          pButton
          class="p-button-secondary"
          icon="pi pi-sliders-h"
        ></button>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4">
    <div class="card relative h-16rem">
      <div class="absolute top-0 left-0" [pTooltip]="totalSqueezedValuesInPeriodTranslation" tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1 flex flex-wrap justify-content-between">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isPeriodDataInfoLoading">
          <span *ngIf="!filtersViewInLiters">{{'misc.overview.totalSqueezedFruitsInPeriod' | transloco}}</span>
          <span *ngIf="filtersViewInLiters">{{'misc.overview.totalSqueezedLitersInPeriod' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isPeriodDataInfoLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div class="flex h-9rem">
        <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!this.isPeriodDataInfoLoading && (this.machinePeriodDataInfo?.totalSqueezedValues == null || this.machinePeriodDataInfo?.totalSqueezedValues == undefined
            || this.machinePeriodDataInfo?.totalSqueezedValues < 0)">
            {{'empty.measures' | transloco}}</span>
        <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isPeriodDataInfoLoading && this.machinePeriodDataInfo != null && this.machinePeriodDataInfo?.totalSqueezedValues >= 0">
                    {{this.machinePeriodDataInfo?.totalSqueezedValues | number:this.filtersViewInLiters ? '.3-3' : '' : this.language}}</span>
        <p-skeleton class="m-auto" *ngIf="this.isPeriodDataInfoLoading" width="30%" height="3rem"></p-skeleton>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4">
    <div class="card relative h-16rem">
      <div class="absolute top-0 left-0" [pTooltip]="squeezedValuesByDayTranslation" tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isPeriodDataInfoLoading">
          <span *ngIf="!filtersViewInLiters">{{'misc.overview.squeezedFruitsByDay' | transloco}}</span>
          <span *ngIf="filtersViewInLiters">{{'misc.overview.squeezedLitersByDay' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isPeriodDataInfoLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div class="flex h-9rem">
        <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!this.isPeriodDataInfoLoading && (this.machinePeriodDataInfo?.squeezedValuesAveragePerDay == null || this.machinePeriodDataInfo?.squeezedValuesAveragePerDay == undefined
            || this.machinePeriodDataInfo?.squeezedValuesAveragePerDay < 0)">
            {{'empty.measures' | transloco}}</span>
        <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isPeriodDataInfoLoading && this.machinePeriodDataInfo != null && this.machinePeriodDataInfo?.squeezedValuesAveragePerDay >= 0">
                    {{this.machinePeriodDataInfo?.squeezedValuesAveragePerDay | number:this.filtersViewInLiters ? '.3-3' : '' : this.language}}</span>
        <p-skeleton class="m-auto" *ngIf="this.isPeriodDataInfoLoading" width="30%" height="3rem"></p-skeleton>
      </div>
    </div>
  </div>
  <div class="col-12 lg:col-4">
    <div class="card relative h-16rem">
      <div class="absolute top-0 left-0" [pTooltip]="squeezedValuesByServiceHourTranslation" tooltipPosition="top">
        <div class="info-background">
          <i class="pi pi-info" style="font-size: 0.8rem"></i>
        </div>
      </div>
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isPeriodDataInfoLoading">
          <span *ngIf="!filtersViewInLiters">{{'misc.overview.squeezedFruitsByServiceHour' | transloco}}</span>
          <span *ngIf="filtersViewInLiters">{{'misc.overview.squeezedLitersByServiceHour' | transloco}}</span>
        </h4>
        <p-skeleton *ngIf="this.isPeriodDataInfoLoading" width="100%" height="2rem"></p-skeleton>
      </div>
      <hr>
      <div class="flex h-9rem">
        <span class="m-auto text-400 font-medium text-xl"
              *ngIf="!this.isPeriodDataInfoLoading && (this.machinePeriodDataInfo?.squeezedValuesAveragePerHour == null || this.machinePeriodDataInfo?.squeezedValuesAveragePerHour == undefined
            || this.machinePeriodDataInfo?.squeezedValuesAveragePerHour < 0)">
            {{'empty.measures' | transloco}}</span>
        <span class="m-auto text-primary font-semibold text-5xl"
              *ngIf="!this.isPeriodDataInfoLoading && this.machinePeriodDataInfo != null && this.machinePeriodDataInfo?.squeezedValuesAveragePerHour >= 0">
                    {{this.machinePeriodDataInfo?.squeezedValuesAveragePerHour | number:this.filtersViewInLiters ? '.3-3' : '' : this.language}}</span>
        <p-skeleton class="m-auto" *ngIf="this.isPeriodDataInfoLoading" width="30%" height="3rem"></p-skeleton>
      </div>
    </div>
  </div>

  <div *ngIf="authGuard.hasPermission(this.PERMISSION_MANAGE_ADVANCED_MACHINES)" class="col-12">
    <div class="card">
      <div class="flex flex-wrap justify-content-between">
        <span class="line-height-4">
            <span class="text-xl font-semibold">{{ 'attribute.period' | transloco}}:</span>&nbsp;
            <span *ngIf="!this.isSpecificPeriodMeasurementsSelected" class="text-md font-medium text-primary">{{ 'misc.' +
            selectedPeriodMeasurements | transloco}}</span>
            <span class="text-md font-medium text-secondary" *ngIf="this.isSpecificPeriodMeasurementsSelected">
                {{ 'attribute.from' | transloco }} <b>{{this.specificPeriodRangeMeasurements[0] | date}}</b> {{
              'attribute.until' | transloco | lowercase}}
              <b>{{this.specificPeriodRangeMeasurements[1]
                | date}}</b>
            </span>
        </span>
        <button [label]="'common.filters' | transloco" (click)="filtersMeasurementsVisible = !filtersMeasurementsVisible" pButton
                class="p-button-secondary" icon="pi pi-sliders-h"></button>
      </div>
    </div>
  </div>
  <div *ngIf="authGuard.hasPermission(this.PERMISSION_MANAGE_ADVANCED_MACHINES)" class="col-12 xl:col-12">
    <div class="card" [ngStyle]="{height: '33rem'}">
      <div class="card-header h-3rem pt-1">
        <h4 class="mt-auto mb-auto line-height-1" *ngIf="!this.isMachineLoading">
          {{'misc.overview.measures' | transloco}}
        </h4>
        <p-skeleton *ngIf="this.isMachineLoading" width="100%" height="2rem"></p-skeleton>
        <div *ngIf="!this.isMachineLoading" class="flex flex-column md:flex-row justify-content-center p-fluid">
          <button
            [disabled]="this.isMachineLoading || !selectedMeasurements || (!this.graphMeasures && selectedMeasurements)"
            type="button"
            pButton
            icon="pi pi-bars"
            class="p-button-secondary"
            label=""
            (click)="signalsAction.toggle($event);exportFileType = ExportFileType.MACHINE_DATA_CHART"
          ></button>
          <p-menu #signalsAction [popup]="true" [model]="chartActions" appendTo="body">
          </p-menu>
        </div>
      </div>
      <hr>
      <div *ngIf="!this.isMachineLoading && !selectedMeasurements" class="flex h-26rem">
        <span class="m-auto text-400 font-medium text-xl">
            {{'empty.selectedMeasurements' | transloco}}</span>
      </div>
      <app-generic-graph id="chart" *ngIf="!this.isMachineLoading && this.graphMeasures && selectedMeasurements"
                         [fileName]="'misc.overview.measures' | transloco"
                         [exportFileType]="ExportFileType.MACHINE_DATA_CHART"
                         [machineSerialNumber]="machine.serial"
                         [data]="this.graphMeasures" [height]="350" [legend]="true"
                         [name]="'attribute.value' | transloco"
                         [customSeries]="true"
                         [bottomLegend]="true"
                         [yAxis]="graphAxis"
                         chartType="line"
                         tooltipDateFormat="%A, %e %b %Y, %H:%M:%S %Z"
                         [pointFormat]="'{series.name}: {point.y:,.f}'"
                         #signalsChart
      >
      </app-generic-graph>
      <div class="w-full" *ngIf="this.isMachineLoading || (this.selectedMeasurements && !this.graphMeasures)">
        <p-skeleton class="m-auto" height="350px">
        </p-skeleton>
      </div>
    </div>
  </div>
</div>

<p-sidebar [(visible)]="filtersVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.period' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-2">
          <p-radioButton name="period" value="lastDay" [(ngModel)]="tempSelectedPeriod" id="period1"
                         (ngModelChange)="selectPeriod('lastDay')" class="mr-2"></p-radioButton>
          <label for="period1">{{ 'misc.lastDay' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="period" value="lastWeek" [(ngModel)]="tempSelectedPeriod" id="period2"
                         (ngModelChange)="selectPeriod('lastWeek')" class="mr-2"></p-radioButton>
          <label for="period2">{{ 'misc.lastWeek' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="period" value="lastMonth" [(ngModel)]="tempSelectedPeriod" id="period3"
                         (ngModelChange)="selectPeriod('lastMonth')" class="mr-2"></p-radioButton>
          <label for="period3">{{ 'misc.lastMonth' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="period" value="specificPeriod" [(ngModel)]="tempSelectedPeriod" id="period4"
                         (ngModelChange)="selectPeriod('specificPeriod')" class="mr-2"></p-radioButton>
          <label for="period4">{{ 'misc.specificPeriod' | transloco }}</label>
          <span *ngIf="this.isSpecificPeriodSelected" class="mt-auto mb-auto mr-3 ml-1">:</span>
        </div>
        <div *ngIf="tempSelectedPeriod[0] === 'specificPeriod'" class="text-right mt-4">
          <p-calendar styleClass="w-full" [ngModel]="tempSpecificPeriodRange" [firstDayOfWeek]="1"
                      [showIcon]="true" [showButtonBar]="true"
                      [monthNavigator]="true" [yearNavigator]="true" [yearRange]="availableYearRange"
                      (ngModelChange)="validatePeriodRange($event)" selectionMode="range" [readonlyInput]="true"
                      inputId="range" dateFormat="dd/mm/yy" appendTo="body" [placeholder]="'select.dateRange' | transloco">
          </p-calendar>
        </div>
      </div>
    </div>
    <div *ngIf="machine?.model.machineType === 'ZITRUX'" class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.variable' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-2">
          <p-radioButton name="variable" [value]="false" [(ngModel)]="filtersViewInLitersTemp" id="variable1" class="mr-2"></p-radioButton>
          <label for="variable1">{{ 'misc.squeezedFruits' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="variable" [value]="true" [(ngModel)]="filtersViewInLitersTemp" id="variable2" class="mr-2"></p-radioButton>
          <label for="variable2">{{ 'misc.squeezedLiters' | transloco }}</label>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <p-button [label]="'common.filter' | transloco" [disabled]="(
            this.tempSelectedPeriod[0] === 'specificPeriod' && !this.isPeriodRangeValid
          )" (onClick)="filtersVisible = false; applySelection()" styleClass="p-button-primary mx-2 mt-2" type="button">
    </p-button>
    <p-button [label]="'common.clear' | transloco" (click)="resetSelection(); filtersVisible = false; applySelection()"
              styleClass="p-button-danger" type="button"></p-button>
  </div>
</p-sidebar>

<p-sidebar *ngIf="authGuard.hasPermission(this.PERMISSION_MANAGE_ADVANCED_MACHINES)"
           [(visible)]="filtersMeasurementsVisible" [baseZIndex]="10000" [style]="{'width':'25em'}" position="right">
  <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
  <div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label>{{'attribute.period' | transloco}}</label>
      </div>
      <div class="col-12">
        <div class="mb-2">
          <p-radioButton name="periodMeasurements" value="lastDay" [(ngModel)]="tempSelectedPeriodMeasurements" id="periodMeasurements1"
                         (ngModelChange)="selectPeriodMeasurements('lastDay')" class="mr-2"></p-radioButton>
          <label for="periodMeasurements1">{{ 'misc.lastDay' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="periodMeasurements" value="lastWeek" [(ngModel)]="tempSelectedPeriodMeasurements" id="periodMeasurements2"
                         (ngModelChange)="selectPeriodMeasurements('lastWeek')" class="mr-2"></p-radioButton>
          <label for="periodMeasurements2">{{ 'misc.lastWeek' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="periodMeasurements" value="lastMonth" [(ngModel)]="tempSelectedPeriodMeasurements" id="periodMeasurements3"
                         (ngModelChange)="selectPeriodMeasurements('lastMonth')" class="mr-2"></p-radioButton>
          <label for="periodMeasurements3">{{ 'misc.lastMonth' | transloco }}</label>
        </div>
        <div class="mb-2">
          <p-radioButton name="periodMeasurements" value="specificPeriod" [(ngModel)]="tempSelectedPeriodMeasurements" id="periodMeasurements4"
                         (ngModelChange)="selectPeriodMeasurements('specificPeriod')" class="mr-2"></p-radioButton>
          <label for="periodMeasurements4">{{ 'misc.specificPeriod' | transloco }}</label>
          <span *ngIf="this.isSpecificPeriodMeasurementsSelected" class="mt-auto mb-auto mr-3 ml-1">:</span>
        </div>
        <div *ngIf="tempSelectedPeriodMeasurements[0] === 'specificPeriod'" class="text-right mt-4">
          <p-calendar styleClass="w-full" [ngModel]="tempSpecificPeriodRangeMeasurements" [firstDayOfWeek]="1"
                      [showIcon]="true" [showButtonBar]="true"
                      [monthNavigator]="true" [yearNavigator]="true" [yearRange]="availableYearRange"
                      (ngModelChange)="validatePeriodRangeMeasurements($event)" selectionMode="range" [readonlyInput]="true"
                      inputId="rangeMeasurements" dateFormat="dd/mm/yy" appendTo="body" [placeholder]="'select.dateRange' | transloco">
          </p-calendar>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="col-12 form-field">
        <label for="measurements">{{'attribute.electricSignals' | transloco}}</label>
      </div>
      <div class="col-12 form-field">
        <p-multiSelect
          [(ngModel)]="selectedMeasurementsUuids"
          [placeholder]="'select.generic' | transloco"
          [filter]="true" display="chip" styleClass="w-full" appendTo="body"
          [options]="measurements"
          id="measurements"
        >
        </p-multiSelect>
      </div>
    </div>
  </div>
  <div class="col-12">
    <p-button [label]="'common.filter' | transloco" [disabled]="(
            !this.selectedMeasurementsUuids || this.selectedMeasurementsUuids.length == 0 ||
            (this.tempSelectedPeriodMeasurements[0] === 'specificPeriod' && !this.isPeriodRangeMeasurementsValid)
          )" (onClick)="filtersMeasurementsVisible = false; applyFilters()" styleClass="p-button-primary mx-2 mt-2" type="button">
    </p-button>
    <p-button [label]="'common.clear' | transloco" (click)="resetFilters(); filtersMeasurementsVisible = false; applyFilters()"
              styleClass="p-button-danger" type="button"></p-button>
  </div>
</p-sidebar>

<app-export-xls *ngIf="exportVisible"
                [content]="getContentExport()"
                [machineSerialNumber]="machine.serial"
                [typeContent]="'MACHINE_DATA'"
                [exportFileType]="exportFileType"
                [typeExport]="'XLSX'"
                [(visible)]="exportVisible">
</app-export-xls>
